let audio: HTMLAudioElement;

const extensions: Record<string, string> = {
    aif: 'audio/x-aiff',
    aiff: 'audio/x-aiff',
    mp3: 'audio/mpeg',
    wav: 'audio/wav',
};

/**
 * Returns true if the HTML5 Audio API is supported for a given audio file extension
 * @param format
 */
export const supportsAudioFormat = (extension: Maybe<string>): boolean => {
    if (extension === null) {
        return false;
    }

    if (extensions[extension] === undefined) {
        return false;
    }

    if (!audio) {
        audio = document.createElement('audio');
    }

    return audio.canPlayType(extensions[extension]) === 'probably';
};
